import { useState } from 'react';
import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  const [errors, setErrors] = useState<Record<number, boolean>>();

  const handleError = (index: number) => {
    setErrors((prev) => ({ ...prev, [index]: true }));
  };

  return (
    <section id="cards" className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
      <div className="w-full">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1.5 h-7 rounded-full bg-accent-500" />
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">推荐内容</h2>
          </div>
          <span className="text-xs text-foreground-500 hidden sm:block">共7篇精选 · 持续更新中</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {cardsData.map((item, index) => {
            const isWide = item.featured;
            return (
              <div
                key={index}
                className={`group rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:border-primary-200 transition-all ${
                  isWide ? 'sm:col-span-2 lg:col-span-2' : ''
                }`}
              >
                <div className={`flex ${isWide ? 'flex-col sm:flex-row' : 'flex-col'} h-full`}>
                  <div className={`relative bg-background-100 overflow-hidden shrink-0 ${
                    isWide ? 'sm:w-[45%] aspect-[4/3] sm:aspect-auto' : 'aspect-[4/3] w-full'
                  }`}>
                    {!errors[index] ? (
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        onError={() => handleError(index)}
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center bg-background-100">
                        <div className="text-center">
                          <i className="ri-image-line text-3xl text-foreground-300 mb-1" />
                          <p className="text-xs text-foreground-400">{item.tag}</p>
                        </div>
                      </div>
                    )}
                    <span className="absolute top-3 left-3 px-2.5 py-1 text-[11px] font-semibold bg-secondary-500 text-background-50 rounded-full">
                      {item.tag}
                    </span>
                  </div>

                  <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                    <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                      {item.desc}
                    </p>
                    <div className="mt-3 flex items-center gap-2 text-primary-600 text-xs font-medium">
                      <span>查看详情</span>
                      <div className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-arrow-right-line" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}